import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ICON_NAMES } from '@/config/config';
import { NavSection } from '@/config/types';

export const newApplicationMenu: NavSection = {
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.APPLICATION,
      icon: ICON_NAMES.APPLICATION,
    },
  ],
};

const salesMenu: NavSection = {
  nameTextId: 'SALES',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.SIMULATOR,
      icon: ICON_NAMES.SIMULATOR,
    },
    {
      path: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST,
      icon: ICON_NAMES.CHECKOUT_SESSION,
    },
  ],
};

export const applicationsMenu: NavSection = {
  nameTextId: 'APPLICATIONS',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.CONSUMER_LOAN_LIST,
      icon: ICON_NAMES.CONSUMER_LOAN,
    },
    {
      path: DYNAMIC_PAGE_PATHS.AUTO_LOAN_LIST,
      icon: ICON_NAMES.AUTO,
    },
    {
      path: DYNAMIC_PAGE_PATHS.CREDIT_LINE_LIST,
      icon: ICON_NAMES.CREDIT_LINE,
    },
    {
      path: DYNAMIC_PAGE_PATHS.CREDIT_CARD_LIST,
      icon: ICON_NAMES.CARD,
    },
    {
      path: DYNAMIC_PAGE_PATHS.ORDER_LIST,
      icon: ICON_NAMES.ORDER,
    },
    {
      path: DYNAMIC_PAGE_PATHS.PAY_BY_LINK_LIST,
      icon: ICON_NAMES.PAY_BY_LINK,
    },
    // {
    //   path: DYNAMIC_PAGE_PATHS.A2A_PAYMENT_LIST,
    //   icon: IconByAllowedPaymentMethodType(PaymentMethodType.A2A_PAYMENT),
    // },
    // {
    //   path: DYNAMIC_PAGE_PATHS.CARD_PAYMENT_LIST,
    //   icon: IconByAllowedPaymentMethodType(PaymentMethodType.CARD_PAYMENT),
    // },
  ],
};

const managementMenu: NavSection = {
  nameTextId: 'MANAGEMENT',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.FUNNEL,
      icon: ICON_NAMES.FUNNEL,
    },
    {
      path: DYNAMIC_PAGE_PATHS.PAYOUTS_LIST,
      icon: ICON_NAMES.PAYOUTS,
    },
    {
      path: DYNAMIC_PAGE_PATHS.REPORTS_LIST,
      icon: ICON_NAMES.REPORTS,
    },
  ],
};

const configurationMenu: NavSection = {
  nameTextId: 'CONFIGURATION',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.MERCHANT_LIST,
      icon: ICON_NAMES.MERCHANT,
    },
    {
      path: DYNAMIC_PAGE_PATHS.PRICINGS_LIST,
      icon: ICON_NAMES.PRICINGS,
    },
    {
      path: DYNAMIC_PAGE_PATHS.INTEGRATIONS,
      icon: ICON_NAMES.INTEGRATIONS,
    },
    {
      path: DYNAMIC_PAGE_PATHS.USERS,
      icon: ICON_NAMES.USERS,
    },
  ],
};

export const iberiaCardsSalesMenu: NavSection = {
  nameTextId: 'SALES',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST,
      icon: ICON_NAMES.CHECKOUT_SESSION,
    },
  ],
};

export const iberiaCardsApplicationsMenu: NavSection = {
  nameTextId: 'APPLICATIONS',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.CREDIT_CARD_LIST,
      icon: ICON_NAMES.CARD,
    },
  ],
};

export const defaultNavMenu: NavSection[] = [
  { ...salesMenu },
  { ...applicationsMenu },
  { ...managementMenu },
  { ...configurationMenu },
];

const teslaSalesMenu: NavSection = {
  nameTextId: 'SALES',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST,
      icon: ICON_NAMES.CHECKOUT_SESSION,
    },
  ],
};

const teslaManagementMenu: NavSection = {
  nameTextId: 'MANAGEMENT',
  links: [
    {
      path: DYNAMIC_PAGE_PATHS.FUNNEL,
      icon: ICON_NAMES.FUNNEL,
    },
  ],
};

export const teslaMerchantChannelAgentNavMenu: NavSection[] = [
  { ...teslaSalesMenu },
  { ...applicationsMenu },
  { ...teslaManagementMenu },
];

export const merchantChannelAgentNavMenu: NavSection[] = [
  { ...newApplicationMenu },
  { ...salesMenu },
  { ...managementMenu },
  { ...configurationMenu },
];

export const cpcBackOfficeNavMenu: NavSection[] = [{ ...salesMenu }, { ...applicationsMenu }, { ...managementMenu }];

export const merchantGroupNavMenu: NavSection[] = [{ ...salesMenu }, { ...managementMenu }, { ...configurationMenu }];

export const lenderNavMenu: NavSection[] = defaultNavMenu;

export const superAdminNavMenu: NavSection[] = defaultNavMenu;
